import { create } from 'zustand';

type InstanceStore<T> = {
  popUpInstances: Record<string, T>;
  addInstance: (id: string, instance: T) => void;
  removeInstance: (id: string) => void;
  getInstance: (id: string) => T | undefined;
};

export const useWebsheetStore = create<InstanceStore<Window>>(set => ({
  popUpInstances: {},

  addInstance: (id, instance) =>
    set(state => ({
      popUpInstances: {
        ...state.popUpInstances,
        [id]: instance,
      },
    })),

  removeInstance: id =>
    set(state => {
      const newInstances = { ...state.popUpInstances };
      delete newInstances[id];
      return { popUpInstances: newInstances };
    }),

  getInstance: id => {
    return useWebsheetStore.getState().popUpInstances[id];
  },
}));
